import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  CustomInput,
} from "reactstrap";
import PropTypes from "prop-types";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

import {
  PhysicalPersonRelationshipAccount,
  PhysicalPersonRelationshipAccountJuridical,
  PersonType,
} from "../Person/types";
import Autosuggest from "../../AutosuggestCompliance";

function holderIsComplete(holder, role) {
  return (
    (holder.PersonId &&
      holder.PersonId > 0 &&
      (Object.keys(PhysicalPersonRelationshipAccount).indexOf(holder.HoldersRelationship) > -1 ||
        role == "Beneficiary") &&
      Object.keys(PhysicalPersonRelationshipAccountJuridical).indexOf(holder.HoldersRelationshipJuridical) >
        -1) ||
    role == "Beneficiary"
  );
}

const initialAccountHolder = (accountId, role) => ({
  AccountId: accountId,
  PersonId: undefined,
  PersonName: undefined,
  PersonType: PersonType.Physical,
  HoldersRelationship: role == "Beneficiary" ? "Beneficiary" : PhysicalPersonRelationshipAccount.Holder,
  HoldersRelationshipJuridical: PhysicalPersonRelationshipAccountJuridical.None,
  HoldersIsManager: false,
  HoldersIsController: false,
  isMainHolder: false,
  deleteHolder: false,
  HoldersOrderManaged: false,
  HoldersOrderWritten: false,
  HoldersOrderWeb: false,
  HoldersOrderViaLink: false,
  AccountHolderIsBeneficiary: role == "Beneficiary",
  HoldersRelationshipDescription: "",
});

const ModalHolder = ({ open, toggle, onSave, account, saving, holders, services, role, Link }) => {
  const [newHolder, setNewHolder] = useState(initialAccountHolder(account.AccountId, role));
  const [personSearch, setPersonSearch] = useState("");
  const [existPerson, setExistPerson] = useState(false);

  const onSuggestionFetchRequested = (value) =>
    new Promise((resolve) => {
      let relation =
        newHolder.HoldersRelationshipJuridical === "Holder" ? PersonType.Juridical : PersonType.Physical;
      if (newHolder.HoldersRelationshipJuridical == "Beneficiary" && !account.AccountIsPhysical)
        relation = PersonType.All;
      services.fetchPersonSuggestion(
        { name: value, personType: account.AccountIsPhysical ? PersonType.Physical : relation },
        (response) => {
          const suggestions = [];
          if (response && response.suggestions) {
            response.suggestions.forEach((p) => {
              let exists = false;
              holders.forEach((h) => {
                if (parseInt(h.AccountHolderId, 10) === parseInt(p.Id, 10) && !h.AccountHolderIsBeneficiary) {
                  exists = true;
                }
              });
              if (!exists) {
                suggestions.push({
                  id: p.Id,
                  name: p.Name,
                });
              }
            });
          }
          resolve(suggestions);
        }
      );
    });

  const onChangeSuggest = (value) => {
    setPersonSearch(String(value));
  };

  const onSuggestionSelected = (id, value) => {
    let relation =
      newHolder.HoldersRelationshipJuridical === "Holder" ? PersonType.Juridical : PersonType.Physical;
    setExistPerson(false);
    let exists = false;
    holders.forEach((h) => {
      if (parseInt(h.AccountHolderId, 10) === parseInt(id, 10) && h.AccountHolderIsBeneficiary) {
        exists = true;
      }
    });
    if (exists) {
      setExistPerson(true);
      setNewHolder({
        ...newHolder,
        PersonId: id,
        PersonName: value,
        AccountHolderIsBeneficiary: true,
        PersonType: relation,
      });
    } else {
      setNewHolder({
        ...newHolder,
        PersonId: id,
        PersonName: value,
        PersonType: relation,
      });
    }
    onChangeSuggest(value);
  };

  const onChange = (name, value) => {
    setNewHolder({
      ...newHolder,
      [name]: value,
    });
  };

  const handleSave = () => {
    const saveHolder = {
      [account.AccountId]: newHolder,
    };
    setPersonSearch("");
    onSave(saveHolder);
    toggle();
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        New Account {role == "Beneficiary" ? "Beneficiary" : "Holder"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Account: </Label>
            <Input value={account.AccountName} />
          </FormGroup>
          {role == "Holder" && (
            <React.Fragment>
              {account.AccountIsPhysical ? (
                <React.Fragment>
                  <FormGroup>
                    <Label
                      style={{
                        fontWeight: 500,
                        fontSize: "15px",
                        display: "flex",
                      }}
                    >
                      Person Relationship:{" "}
                    </Label>
                    <Input
                      type="select"
                      onChange={(e) => onChange("HoldersRelationship", e.target.value)}
                      value={newHolder.HoldersRelationship}
                    >
                      {Object.keys(PhysicalPersonRelationshipAccount).map((key) => (
                        <option key={key} value={key}>
                          {PhysicalPersonRelationshipAccount[key]}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      style={{
                        fontWeight: 500,
                        fontSize: "15px",
                        display: "flex",
                      }}
                    >
                      Is Beneficiary?{" "}
                    </Label>
                    <CustomInput
                      id="IsBeneficiary"
                      type="checkbox"
                      label="Beneficiary"
                      checked={newHolder.AccountHolderIsBeneficiary}
                      onChange={(e) => onChange("AccountHolderIsBeneficiary", e.target.checked)}
                    />
                    {existPerson && (
                      <div
                        style={{
                          margin: "-4px 20px 0 12px",
                          padding: "4px 10px",
                          fontSize: "13px",
                          color: "#94793b",
                          backgroundColor: "#fef1d8",
                          borderColor: "#feecc9",
                          display: "flex",
                        }}
                      >
                        <i
                          className="icon-exclamation icons font-xl d-block"
                          style={{ color: "orange", marginRight: "5px" }}
                        ></i>
                        Person already exists in Beneficiary Tab, "Is Beneficiary" is clicked by default
                      </div>
                    )}
                  </FormGroup>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <FormGroup>
                    <Label
                      style={{
                        fontWeight: 500,
                        fontSize: "15px",
                        display: "flex",
                      }}
                    >
                      Person Relationship Juridical:
                    </Label>
                    <Input
                      type="select"
                      onChange={(e) => onChange("HoldersRelationshipJuridical", e.target.value)}
                      value={newHolder.HoldersRelationshipJuridical}
                    >
                      {Object.keys(PhysicalPersonRelationshipAccountJuridical).map((key) => (
                        <option key={key} value={key}>
                          {PhysicalPersonRelationshipAccountJuridical[key]}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      check
                      style={{
                        fontWeight: 500,
                        fontSize: "15px",
                        display: "block",
                      }}
                    >
                      Holder is Controller:
                      <Input
                        type="checkbox"
                        style={{ marginLeft: 10 }}
                        value={newHolder.HoldersIsController}
                        onChange={() => onChange("HoldersIsController", !newHolder.HoldersIsController)}
                      />
                    </Label>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      check
                      style={{
                        fontWeight: 500,
                        fontSize: "15px",
                        display: "block",
                      }}
                    >
                      Holder is Manager:
                      <Input
                        type="checkbox"
                        style={{ marginLeft: 10 }}
                        value={newHolder.HoldersIsManager}
                        onClick={() => onChange("HoldersIsManager", !newHolder.HoldersIsManager)}
                      />
                    </Label>
                  </FormGroup>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          <FormGroup>
            <Label>Person: </Label>
            <div></div>
            {account.AccountStatus === "InProcess" && (
              <Label>
                {" "}
                Check if the person already exists, insert document number here{" "}
                <i class="fa fa-hand-o-down" aria-hidden="true"></i>
              </Label>
            )}
            <Autosuggest
              value={personSearch}
              onSelect={onSuggestionSelected}
              onChange={onChangeSuggest}
              fecthSuggestions={onSuggestionFetchRequested}
            />
          </FormGroup>
          <FormGroup>
            <Label
              check
              style={{
                fontWeight: 500,
                fontSize: "15px",
                display: "block",
              }}
            >
              Holder Relationship Description:
              <Input
                type="text"
                style={{ marginLeft: 5 }}
                value={newHolder.HoldersRelationshipDescription}
                onChange={(e) => onChange("HoldersRelationshipDescription", e.target.value)}
              />
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={saving}
          disabled={!holderIsComplete(newHolder, role)}
          onClick={() => handleSave()}
          data-style={EXPAND_RIGHT}
        >
          {saving ? "Saving" : "Save"}
        </LaddaButton>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalHolder.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  account: PropTypes.object.isRequired,
  saving: PropTypes.func.isRequired,
  holders: PropTypes.array.isRequired,
  services: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
};

export default ModalHolder;
